import { render, staticRenderFns } from "./ReportbForm.vue?vue&type=template&id=c0846580&scoped=true&"
import script from "./ReportbForm.vue?vue&type=script&lang=js&"
export * from "./ReportbForm.vue?vue&type=script&lang=js&"
import style0 from "./ReportbForm.vue?vue&type=style&index=0&id=c0846580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0846580",
  null
  
)

export default component.exports